{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/participant",
  "title": "Participant",
  "description": "Equity plan participant — personal info, employment, addresses, compliance, transfer agent.",
  "type": "object",
  "properties": {
    "payrollId": {
      "$ref": "module://participant#properties/payrollId"
    },
    "employeeId": {
      "$ref": "module://participant#properties/employeeId",
      "required": true
    },
    "employeeTypeId": {
      "$ref": "module://participant#properties/employeeTypeId"
    },
    "firstName": {
      "$ref": "module://participant#properties/firstName",
      "required": true
    },
    "middleName": {
      "$ref": "module://participant#properties/middleName"
    },
    "lastName": {
      "$ref": "module://participant#properties/lastName",
      "required": true
    },
    "dateOfBirth": {
      "$ref": "module://participant#properties/dateOfBirth",
      "required": true
    },
    "workNumberCountryCodeId": {
      "$ref": "module://participant#properties/workNumberCountryCodeId"
    },
    "workNumber": {
      "$ref": "module://participant#properties/workNumber",
      "inputFormatterWhen": {
        "field": "#/properties/isOtherCountryPhone",
        "equals": true
      },
      "inputFormatterFalse": "PHONE_US"
    },
    "email": {
      "$ref": "module://participant#properties/email",
      "required": true
    },
    "residentStatusId": {
      "$ref": "module://participant#properties/residentStatusId"
    },
    "residentStatusName": {
      "$ref": "module://participant#properties/residentStatusName"
    },
    "countryId": {
      "$ref": "module://participant#properties/countryId"
    },
    "ssn": {
      "$ref": "module://participant#properties/ssn",
      "inputFormatterWhen": {
        "field": "#/properties/participantOtherCountry",
        "notEquals": true
      }
    },
    "divisionId": {
      "$ref": "module://participant#properties/divisionId"
    },
    "titleId": {
      "$ref": "module://participant#properties/titleId"
    },
    "costCenter": {
      "$ref": "module://participant#properties/costCenter"
    },
    "hireDate": {
      "$ref": "module://participant#properties/hireDate"
    },
    "isSection16": {
      "$ref": "module://participant#properties/isSection16"
    },
    "isRule144": {
      "$ref": "module://participant#properties/isRule144"
    },
    "settlementTypeId": {
      "$ref": "module://settlement#/$defs/settlementTypeId",
      "hiddenWhen": {
        "meta": "env",
        "in": ["development", "qa"]
      }
    },
    "employmentAddressLine1": {
      "$ref": "module://participant#properties/employmentAddressLine1"
    },
    "employmentAddressLine2": {
      "$ref": "module://participant#properties/employmentAddressLine2"
    },
    "employmentCountryId": {
      "$ref": "module://participant#properties/employmentCountryId"
    },
    "employmentZipCode": {
      "$ref": "module://participant#properties/employmentZipCode"
    },
    "employmentStateId": {
      "$ref": "module://participant#properties/employmentStateId",
      "dependsOn": "employmentCountryId",
      "paramMap": {
        "countryId": "employmentCountryId"
      },
      "hiddenWhen": {
        "field": "#/properties/isOtherCountry",
        "equals": true
      }
    },
    "employmentStateText": {
      "$ref": "module://participant#properties/employmentStateText",
      "hiddenWhen": {
        "field": "#/properties/isOtherCountry",
        "notEquals": true
      }
    },
    "employmentCityText": {
      "$ref": "module://participant#properties/employmentCityText"
    },
    "isOtherCountry": {
      "$ref": "module://participant#properties/isOtherCountry"
    },
    "homeAddressLine1": {
      "$ref": "module://participant#properties/homeAddressLine1"
    },
    "homeAddressLine2": {
      "$ref": "module://participant#properties/homeAddressLine2"
    },
    "homeCountryId": {
      "$ref": "module://participant#properties/homeCountryId"
    },
    "homeZipCode": {
      "$ref": "module://participant#properties/homeZipCode"
    },
    "homeStateId": {
      "$ref": "module://participant#properties/homeStateId",
      "dependsOn": "homeCountryId",
      "paramMap": {
        "countryId": "homeCountryId"
      },
      "hiddenWhen": {
        "field": "#/properties/isHomeOtherCountry",
        "equals": true
      }
    },
    "homeStateText": {
      "$ref": "module://participant#properties/homeStateText",
      "hiddenWhen": {
        "field": "#/properties/isHomeOtherCountry",
        "notEquals": true
      }
    },
    "homeCityText": {
      "$ref": "module://participant#properties/homeCityText"
    },
    "isHomeOtherCountry": {
      "$ref": "module://participant#properties/isHomeOtherCountry"
    },
    "isMailingAddressDifferent": {
      "$ref": "module://participant#properties/isMailingAddressDifferent"
    },
    "mailingAddressLine1": {
      "$ref": "module://participant#properties/mailingAddressLine1",
      "hiddenWhen": {
        "field": "#/properties/isMailingAddressDifferent",
        "notEquals": true
      }
    },
    "mailingAddressLine2": {
      "$ref": "module://participant#properties/mailingAddressLine2",
      "hiddenWhen": {
        "field": "#/properties/isMailingAddressDifferent",
        "notEquals": true
      }
    },
    "mailingCountryId": {
      "$ref": "module://participant#properties/mailingCountryId",
      "hiddenWhen": {
        "field": "#/properties/isMailingAddressDifferent",
        "notEquals": true
      }
    },
    "mailingZipCode": {
      "$ref": "module://participant#properties/mailingZipCode",
      "hiddenWhen": {
        "field": "#/properties/isMailingAddressDifferent",
        "notEquals": true
      }
    },
    "mailingStateId": {
      "$ref": "module://participant#properties/mailingStateId",
      "dependsOn": "mailingCountryId",
      "paramMap": {
        "countryId": "mailingCountryId"
      },
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isMailingAddressDifferent",
            "notEquals": true
          },
          {
            "field": "#/properties/isMailingOtherCountry",
            "equals": true
          }
        ]
      }
    },
    "mailingStateText": {
      "$ref": "module://participant#properties/mailingStateText",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isMailingAddressDifferent",
            "notEquals": true
          },
          {
            "field": "#/properties/isMailingOtherCountry",
            "notEquals": true
          }
        ]
      }
    },
    "mailingCityText": {
      "$ref": "module://participant#properties/mailingCityText",
      "hiddenWhen": {
        "field": "#/properties/isMailingAddressDifferent",
        "notEquals": true
      }
    },
    "isMailingOtherCountry": {
      "$ref": "module://participant#properties/isMailingOtherCountry"
    },
    "transferAgentCompanyId": {
      "$ref": "module://participant#properties/transferAgentCompanyId"
    },
    "taAccountNumber": {
      "$ref": "module://participant#properties/taAccountNumber"
    },
    "taName": {
      "$ref": "module://participant#properties/taName"
    },
    "isOtherCountryPhone": {
      "$ref": "module://participant#properties/isOtherCountryPhone"
    },
    "participantOtherCountry": {
      "$ref": "module://participant#properties/participantOtherCountry"
    },
    "employeeStatus": {
      "$ref": "module://participant#properties/employeeStatus"
    },
    "settlementConfiguration": {
      "$ref": "module://settlement#/$defs/settlementConfiguration",
      "hiddenWhen": {
        "meta": "env",
        "in": ["uat", "production"]
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_PARTICIPANT",
      "successMessage": "Participant saved",
      "refreshEntities": [
        "Participant"
      ]
    }
  },
  "modes": {
    "create": {
      "type": "array",
      "items": {
        "$ref": "#"
      },
      "minItems": 1,
      "maxItems": 25,
      "dataSource": {
        "submit": {
          "constants": {
            "importType": "add",
            "employeeStatus": "Active"
          },
          "successMessage": "Participants added"
        }
      },
      "lifecycle": {
        "submitBehavior": "reset"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PARTICIPANT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "constants": {
            "importType": "edit"
          },
          "successMessage": "Participant updated successfully"
        }
      },
      "lifecycle": {
        "submitBehavior": "stay"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PARTICIPANT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
